import React from "react";
import "./TypingAnimation.css";

const TypingAnimation = () => {
  return (
    <div className="dotsContainer">
      <span id="dot1"></span>
      <span id="dot2"></span>
      <span id="dot3"></span>
    </div>
  );
};

export default TypingAnimation;